import React, { Fragment } from 'react';
import ImageUploading from 'react-images-uploading';
import { ADD_IMAGE } from '../../globals';
// Portr SDK - api class and methods
import PortrSDK from 'portr-javascript-sdk';
import LoadingScreenComponent from '../loader/loading-screen.component';
import ToastComponent, { closeToast } from '../toast/toast.component';
import tickIcon from './../../images/tick-blue.svg';
import { replaceCount } from '../../services/string-helper';
const camOutlineblue = require('./../../images/cam-outline-blue.svg');
const portrSDK = new PortrSDK();
// images
const imgClose = require('../../images/icon_close.svg');
const imgExample = require('../../images/example-bag-image.png');
const arrowRight = require('../../images/right-arrow.svg');
const arrowBottom = require('../../images/bottom-arrow.svg');
// styles
const styles = require('./baggage-upload.scss');
const API_PATH = process.env.REACT_APP_API_URL;
const SUBSCRIPTIONKEY = process.env.REACT_APP_SUBSCRIPTION_KEY;
const header = {
    'Ocp-Apim-Subscription-Key': SUBSCRIPTIONKEY,
};

declare var exponea: any;
interface IProps {
    bookingJourneyReference: string;
    userBookingRef: string;
    language: string;
    multiLang: any;
    getData: Function;
    queryParams: any;
    trackingData: any;
    userEmail: string;
}

interface IState {
    showOverlay: boolean;
    overlayClasses: string;
    images: Array<any>;
    compressedImages: Array<any>;
    uploadBaggageSuccess: boolean;
    uploading: boolean;
    error: any;
    isActive: boolean;
    showManualIataContent: boolean;
    iataInputText: string;
    iataInputID: number;
    errorMsg: string;
}
const maxNumber = 25;
let toastIndex = 0;
class BaggageUploadComponent extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props);

        const details = props.trackingData.trackingBookingDetails;
        const isTaskDOne = details.noOfPreCheckinImages >= details.noOfBookedBags;

        this.state = {
            showOverlay: false,
            overlayClasses: styles.modalWrapper,
            images: [],
            compressedImages: [],
            uploadBaggageSuccess: isTaskDOne,
            uploading: false,
            error: false,
            isActive: false,
            showManualIataContent: false,
            iataInputText: '',
            iataInputID: 1,
            errorMsg: '',
        };
    }

    componentDidMount() { }

    toggleCollapsible = () => {
        this.setState((prevState) => ({
            isActive: !prevState.isActive,
        }));
    };

    uploadImage = async (request) => {
        let isSuccess = true;
        let error = null;
        const res = await portrSDK.getTrackingDataWithHeader(
            API_PATH,
            ADD_IMAGE,
            'post',
            null,
            request,
            header
        );

        if (res.status && res.status >= 400) {
            isSuccess = false;
            error = res.data.validationErrors;
        }
        return [isSuccess, error];
    };

    // Compress a single image
    compressImage = (imageFile) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result as string;

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    const maxWidth = 800; // Set max width or height
                    const maxHeight = 800;
                    let width = img.width;
                    let height = img.height;

                    // Maintain aspect ratio
                    if (width > height) {
                        if (width > maxWidth) {
                            height *= maxWidth / width;
                            width = maxWidth;
                        }
                    } else {
                        if (height > maxHeight) {
                            width *= maxHeight / height;
                            height = maxHeight;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0, width, height);

                    // Convert canvas to blob (compressed image)
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                const compressedImage = new File([blob], imageFile.name, {
                                    type: 'image/jpeg',
                                    lastModified: Date.now(),
                                });
                                resolve(compressedImage); // Resolve compressed image
                            } else {
                                reject(new Error('Compression failed'));
                            }
                        },
                        'image/jpeg',
                        0.7
                    ); // Adjust quality here (0.7 is 70%)
                };

                img.onerror = () => reject(new Error('Image load error'));
            };

            reader.onerror = () => reject(new Error('File reader error'));
            reader.readAsDataURL(imageFile);
        });
    };

    onSendImageHandler = async () => {
        this.setState({ uploading: true });
        const images = [...this.state.images];
        if (images.length > 0) {
            this.setState({ uploading: true });
            const promises = await images.map((image) =>
                this.compressImage(image.file)
            );

            Promise.all(promises).then((compressedImages) => {
                this.setState({ compressedImages }, async () => {
                    // Constants for better maintainability
                    const UPLOAD_DELAY_MS = 200;
                    const failedImageIndices: number[] = [];
                    const uploadErrors: any[] = [];

                    // Sequential upload with delay to avoid server overload
                    for (let i = 0; i < this.state.compressedImages.length; i++) {
                        const img = this.state.compressedImages[i];
                        const request = new FormData();
                        request.append(
                            'data',
                            `{'bookingReference': '${this.props.userBookingRef}', 'bookingJourneyReference': '${this.props.bookingJourneyReference}', 'imageType': 'PreCheckinLuggage','emailAddress': '${this.props.userEmail}'}`
                        );
                        request.append('datafile', img);

                        try {
                            const [isSuccess, error] = await this.uploadImage(request);
                            if (!isSuccess) {
                                failedImageIndices.push(i);
                                if (error) {
                                    uploadErrors.push(
                                        ...(Array.isArray(error) ? error : [error])
                                    );
                                }
                            }
                        } catch (uploadError) {
                            // Handle unexpected errors during upload
                            failedImageIndices.push(i);
                            uploadErrors.push('Upload failed unexpectedly');
                        }

                        // Add delay between uploads (except after the last one)
                        if (i < this.state.compressedImages.length - 1) {
                            await new Promise((resolve) =>
                                setTimeout(resolve, UPLOAD_DELAY_MS)
                            );
                        }
                    }

                    // Process results after all uploads
                    const failedImages = images.filter((_, index) =>
                        failedImageIndices.includes(index)
                    );
                    const hasFailures = failedImageIndices.length > 0;

                    // Batch state updates for better performance
                    this.setState((prevState) => ({
                        images: failedImages,
                        uploadBaggageSuccess: !hasFailures,
                        error: hasFailures ? uploadErrors : [],
                        uploading: false,
                    }));

                    // Track upload success/failure
                    exponea.track('ccd_baggage_uploaded', {
                        email: this.props.queryParams.email,
                        upload_successful: !hasFailures,
                    });

                    // Refresh data
                    // call this api after 200ms to ensure backend has processed the images
                    setTimeout(() => {
                        this.props.getData();
                    }, UPLOAD_DELAY_MS);
                });
            });
        }
    };

    onImageChange = (imageList, addUpdateIndex) => {
        this.setState({ images: imageList });
    };

    errorHandler = (error) => {
        if (typeof error === 'string') {
            toastIndex += 1;
            return <ToastComponent message={error} type='error' index={toastIndex} />;
        } else {
            return error.map((err, i) => {
                toastIndex += 1;
                return (
                    <ToastComponent
                        key={i}
                        message={err}
                        type='error'
                        index={toastIndex}
                    />
                );
            });
        }
    };

    public render() {
        const { multiLang, language, trackingData } = this.props;
        const { isActive } = this.state;

        const details = trackingData.trackingBookingDetails;
        const noOfBookedBags = details.noOfBookedBags;
        const requiredNoOfImages = details.noOfBookedBags - details.noOfPreCheckinImages;
        const taskDone = details.noOfPreCheckinImages >= details.noOfBookedBags;

        const isSuccess = this.state.uploadBaggageSuccess || taskDone;

        return (
            <Fragment>
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <span className={isSuccess ? styles.taskDone : ''}>
                            {isSuccess
                                ? multiLang['doneText' + language]
                                : multiLang['uploadBaggageImages' + language]}
                        </span>
                    </div>
                    <div className={styles.cardBody}>
                        {isSuccess ? (
                            <>
                                <img className={styles.centerImg} src={tickIcon} alt='' />
                                <h2 className={styles.textCenter}>
                                    {multiLang['thanksText' + language]}
                                </h2>
                                <p>
                                    {noOfBookedBags > 1
                                        ? multiLang['thankYouMessageBaggageImages' + language]
                                        : multiLang['thankYouMessageBaggageImage' + language]}
                                </p>
                            </>
                        ) : (
                            <>
                                <div className={styles.contentWrapper}>
                                    <p>
                                        {multiLang[`uploadBaggageImagesHelpText${language}`]}

                                        <span className='tooltip'>
                                            <i className='fa fa-info-circle' aria-hidden='true'></i>
                                            <span className='tooltiptext'>
                                                {multiLang[`uploadBaggageImagesHelpText_additional${language}`]}
                                            </span>
                                        </span>
                                    </p>
                                    <ul>
                                        <li>
                                            {multiLang[`uploadBaggageImagesHelpText_instruction_one${language}`]}
                                        </li>
                                        <li>{multiLang[`uploadBaggageImagesHelpText_instruction_two${language}`]}</li>
                                    </ul>
                                </div>
                                {this.state.uploading ? (
                                    <>
                                        <div className={styles.backdrop}></div>
                                        <LoadingScreenComponent
                                            data={null}
                                        ></LoadingScreenComponent>
                                    </>
                                ) : null}

                                {this.state.images.length === 0 && (
                                    <div className={styles.instructions}>
                                        <span
                                            className={`collapsible ${isActive ? 'active' : ''}`}
                                            onClick={this.toggleCollapsible}
                                        >
                                            <span>{multiLang['exampleBaggage' + language]}</span>{' '}
                                            <img src={isActive ? arrowBottom : arrowRight} alt='' />
                                        </span>
                                        <div
                                            className='content'
                                            style={{ maxHeight: isActive ? '1000px' : '0px' }}
                                        >
                                            <img src={imgExample} />
                                        </div>
                                    </div>
                                )}

                                <ImageUploading
                                    multiple
                                    value={this.state.images}
                                    onChange={this.onImageChange}
                                    maxNumber={maxNumber}
                                    dataURLKey='data_url'
                                    acceptType={['jpg', 'jpeg', 'png']}
                                >
                                    {({
                                        imageList,
                                        onImageUpload,
                                        onImageRemoveAll,
                                        onImageUpdate,
                                        onImageRemove,
                                        isDragging,
                                        dragProps,
                                    }) => (
                                        <>
                                            <div className={styles.uploadImageWrapper}>
                                                {imageList.map((image, index) => (
                                                    <>
                                                        {
                                                        image?.data_url && (<div key={index} className={styles.imageItem}>
                                                            <span>
                                                                {replaceCount(
                                                                    multiLang[`uploadImageLabel${language}`],
                                                                    index + 1
                                                                )}
                                                            </span>
                                                            <div className={styles.imageWrapper}>
                                                                <div
                                                                    className={styles.imagePreview}
                                                                    style={{
                                                                        backgroundImage:
                                                                            'url(' + image.data_url + ')',
                                                                    }}
                                                                ></div>
                                                                <div
                                                                    className={styles.crossIcon}
                                                                    onClick={() => onImageRemove(index)}
                                                                >
                                                                    <img src={imgClose} />
                                                                </div>
                                                            </div>
                                                        </div>)
                                                        }
                                                    </>
                                                ))}
                                                {this.state.images.length === 0 && (
                                                    <>
                                                        <button onClick={onImageUpload}>
                                                            <img
                                                                className={styles.btnImg}
                                                                src={camOutlineblue}
                                                                alt=''
                                                            />
                                                            {multiLang['addBagImageButton' + language]}
                                                        </button>
                                                    </>
                                                )}
                                            </div>

                                                {this.state.images.length > 0 &&
                                                this.state.images.length <
                                                requiredNoOfImages && (
                                                    <div className={styles.uploadImageWrapper}>
                                                        {Array(
                                                            requiredNoOfImages - imageList.length
                                                        )
                                                            .fill(null)
                                                            .map((_, i) => {
                                                                return (
                                                                    <div key={i} className={styles.imageItem}>
                                                                        <span>
                                                                            {replaceCount(
                                                                                multiLang[
                                                                                `uploadImageLabel${language}`
                                                                                ],
                                                                                i + imageList.length + 1
                                                                            )}
                                                                        </span>

                                                                        <button
                                                                            className={styles.btnAddAnother}
                                                                            onClick={onImageUpload}
                                                                        >
                                                                            <img
                                                                                className={styles.btnImg}
                                                                                src={camOutlineblue}
                                                                                alt=''
                                                                            />
                                                                            {multiLang['uploadBagImageButton' + language]}
                                                                        </button>
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>
                                                )}

                                            {this.state.images.length !== 0 && (
                                                <div className={styles.instructions}>
                                                    <span
                                                        className={`collapsible ${isActive ? 'active' : ''}`}
                                                        onClick={this.toggleCollapsible}
                                                    >
                                                        <span>{multiLang['exampleBaggage' + language]}</span>{' '}
                                                        <img src={isActive ? arrowBottom : arrowRight} alt='' />
                                                    </span>
                                                    <div
                                                        className='content'
                                                        style={{ maxHeight: isActive ? '1000px' : '0px' }}
                                                    >
                                                        <img src={imgExample} />
                                                    </div>
                                                </div>
                                            )}

                                            {this.state.images.length !== 0 && (
                                                <button
                                                    disabled={
                                                        this.state.images.length !==
                                                        requiredNoOfImages
                                                    }
                                                    className={styles.btnSendPicture}
                                                    onClick={this.onSendImageHandler}
                                                >
                                                    {`${multiLang['submitButton' + language]} ${this.state.images.length} ${multiLang['ofText' + language]} ${requiredNoOfImages}`}
                                                </button>
                                            )}
                                        </>
                                    )}
                                </ImageUploading>
                                <div>
                                    {this.state.error.length > 0 ? (
                                        <>
                                            <button
                                                className={styles.closeBtn}
                                                onClick={() => {
                                                    closeToast();
                                                    this.setState({ error: [] });
                                                }}
                                            >
                                                x
                                            </button>
                                            {this.errorHandler(this.state.error[0])}
                                        </>
                                    ) : null}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default BaggageUploadComponent;



// WEBPACK FOOTER //
// ./src/components/ccd-baggage-img-upload/baggage-upload.component.tsx